import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "store/auth";

const SideBar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentMenu] = location.pathname.slice(1).split("/");
  const [activeMenu, setActiveMenu] = useState(currentMenu);
  const auth = useAuth();

  return (
    <>
      <nav className="side-nav">
        <ul className="sticky top-4">
          <li className="text-white flex justify-center flex-col items-center gap-y-3">
            <div
              role="button"
              aria-expanded="false"
              className="dropdown-toggle w-12 h-12 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110"
            >
              <img alt="هاشور" src="/images/account.jpg" />
            </div>
            <span>
              {(auth.userMeta && auth.userMeta.first_name) +
                " " +
                (auth.userMeta && auth.userMeta.last_name)}
            </span>
          </li>
          <div className="side-nav__devider my-3"></div>
          {auth.userMeta &&
            auth.userMeta.panel_menus &&
            auth.userMeta.panel_menus.length > 1 &&
            auth.userMeta.panel_menus.map((item) => (
              <>
                {item.allow && (
                  <li>
                    <a
                      href="javascript:;"
                      onClick={() => {
                        setActiveMenu(item.to);
                        if (item.childs.length < 1) navigate(item.to);
                      }}
                      className={`side-menu ${
                        "/" + activeMenu == item.to || activeMenu == item.to
                          ? "side-menu--active"
                          : ""
                      }`}
                    >
                      <div className="side-menu__icon">
                        <IconLoader name={item.icon} />
                      </div>
                      <div className="side-menu__title">
                        {item.title}

                        {item.notification_count > 0 && (
                          <span
                            style={{
                              display: "block",
                              width: 20,
                              height: 20,
                              borderRadius: "100%",
                              backgroundColor: "red",
                              fontSize: 12,
                              padding: 3,
                              margin: 3,
                              color: "white",
                            }}
                          >
                            {item.notification_count}
                          </span>
                        )}
                        <div className="side-menu__sub-icon ">
                          {item.childs.length > 0 && <Icons.ChevronDown />}
                        </div>
                      </div>
                    </a>
                    <ul
                      className={`${
                        activeMenu == item.to ? "side-menu__sub-open" : ""
                      }`}
                    >
                      {item.childs &&
                        item.childs.length > 0 &&
                        item.childs.map((c_item) => (
                          <>
                            {c_item.allow && (
                              <li>
                                <Link to={c_item.to} className="side-menu">
                                  <div className="side-menu__icon">
                                    <IconLoader name={c_item.icon} />
                                  </div>
                                  <div className="side-menu__title">
                                    {c_item.title}
                                    {c_item.notification_count > 0 && (
                                      <span
                                        style={{
                                          display: "block",
                                          width: 20,
                                          height: 20,
                                          borderRadius: "100%",
                                          backgroundColor: "red",
                                          fontSize: 12,
                                          padding: 3,
                                          margin: 3,
                                          color: "white",
                                        }}
                                      >
                                        {c_item.notification_count}
                                      </span>
                                    )}
                                  </div>
                                </Link>
                              </li>
                            )}
                          </>
                        ))}
                    </ul>
                  </li>
                )}
              </>
            ))}
        </ul>
      </nav>
    </>
  );
};

export default SideBar;
const IconLoader = (props) => {
  const Dicn = Icons[props.name];
  return <Dicn {...props.rest} />;
};
